<template>
  <div id="global-pagination" class="page">
    <!-- 分页 -->

    <el-pagination
      v-if="topPagination"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 30, 50, 100, 200]"
      :page-size="pageSize"
      background
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    ></el-pagination>

    <div style="padding-top: 10px 0">
      <slot name="title"></slot>
    </div>

    <!-- 表格 -->

    <div style="padding-bottom: 10px 0">
      <!-- <div style="padding: 10px 0"> -->
      <slot name="table"></slot>
    </div>

    <!-- 分页 -->

    <el-pagination
      v-if="bottomPagination"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 30, 50, 100, 200]"
      :page-size="pageSize"
      background
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
      <!-- <span plain style="position:absolute;right:25px" class="export">导出</span> -->
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: "global-pagination",
  components: {},
  props: {
    topPagination: {
      type: Boolean,
      default: true,
    },
    bottomPagination: {
      type: Boolean,
      default: true,
    },
    total: {
      // 总条数
      type: Number,
      default: 0,
    },
    currentPage: {
      type: Number,
      default: 1,
    },
    pageSize: {
      type: Number,
      default: 10,
    },
  },
  watch: {
    total(newValue, oldValue) {
      // console.log("33333333333333333", newValue);
    },
  },
  data() {
    return {
      page: 1,
    };
  },

  methods: {
    // 监听当前页数变化
    handleCurrentChange(val) {
      console.log("handle-current-change", val, this.$parent);
      this.$emit("handle-current-change", val);
    },

    // 监听当前页多少条变化
    handleSizeChange(val) {
      console.log("handle-size-change", val);
      this.$emit("handle-size-change", val);
    },
  },
};
</script>
<style lang="scss" scoped>
#global-pagination {
  // /deep/ .el-pagination.is-background .el-pager li:not(.disabled) {
  //   background-color: #fff; // 进行修改未选中背景和字体
  //   // color: #fff;
  // }
}
</style>


// WEBPACK FOOTER //
// src/components/common/pagination.vue